import { Link } from 'react-router-dom'
import { ShieldCheck } from '@/assets/icons'
import { ExternalStorageFooterVariant } from '@/user_files/external-storage/menu-state'

type FilePickerSecurityFooterProps = {
  variant: ExternalStorageFooterVariant
  /** Called before navigating to Global Settings, e.g. to close the popover/dropdown. */
  onNavigate?: () => void
}

/**
 * Footer for the file-picker surfaces. Shows the plain "your documents are secure" shield by
 * default, and swaps to a "connect your DMS" call-to-action when no DMS account is connected
 * (see useExternalStorageMenuStatus.footerVariant).
 *
 * Rendered as a full-bleed direct child of MenuContent (which is chrome-only, no padding) or of
 * Popover.Content. It owns its own edge-to-edge padding and bottom rounding.
 */
export function FilePickerSecurityFooter({ variant, onNavigate }: FilePickerSecurityFooterProps) {
  if (variant === ExternalStorageFooterVariant.ConnectDms) {
    return (
      <div className="flex items-center rounded-b-lg border border-brand-neutral-200 bg-brand-neutral-100 px-4 py-2">
        <p className="text-[12px] font-medium leading-4 text-brand-neutral-800">
          Go to{' '}
          <Link to="/dashboard/settings" className="underline hover:text-brand-neutral-950" onClick={onNavigate}>
            Global Settings
          </Link>{' '}
          to connect your DMS
        </p>
      </div>
    )
  }

  return (
    <div className="flex items-center rounded-b-lg border border-brand-100 bg-brand-50 px-4 py-[10px] text-brand-800">
      <ShieldCheck className="mr-1 h-4 w-4" />
      <span className="text-[12px] font-medium">Your documents and data are secure</span>
    </div>
  )
}
